<a
  [routerLink]="['/blog', post().slug]"
  class="group flex h-full flex-col overflow-hidden rounded-lg border border-line bg-surface"
>
  @if (post().image; as image) {
  <img
    [src]="image"
    [alt]="post().title"
    class="aspect-[16/9] w-full object-cover"
    [attr.loading]="eager() ? 'eager' : 'lazy'"
    [attr.fetchpriority]="eager() ? 'high' : null"
    decoding="async"
    width="1200"
    height="675"
  />
  } @else {
  <!-- No cover. The band, rather than a gap where a picture should be. -->
  <div class="band-full flex aspect-[16/9] w-full items-end p-8">
    <span class="text-kicker uppercase text-accent-200">Ledgerly</span>
  </div>
  }

  <div class="flex flex-1 flex-col p-8">
    <p class="text-sub uppercase tracking-[0.1em] text-accent">{{ date }}</p>
    <h3
      class="mt-3 text-[19px] font-medium leading-[1.3] tracking-[-0.015em] text-ink"
    >
      {{ post().title }}
    </h3>
    <p class="mt-4 line-clamp-3 text-subline text-ink-2">
      {{ post().description }}
    </p>
  </div>
</a>
